import { render } from "./mvt-factcard.vue?vue&type=template&id=1ed04548"
import script from "./mvt-factcard.js?vue&type=script&lang=js"
export * from "./mvt-factcard.js?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__